<template>
  <div class="subscription-example">
    <h1>Premium Features</h1>
    
    <div class="content-section">
      <div class="intro-text">
        <h2>Get more from your conversations</h2>
        <p>Unlock exclusive features and enhance your experience with premium access.</p>
      </div>
      
      <div class="premium-features">
        <div class="feature-card">
          <div class="feature-icon">🎭</div>
          <div class="feature-content">
            <h3>Access All Characters</h3>
            <p>Chat with premium characters and unlock exclusive conversations.</p>
          </div>
        </div>
        
        <div class="feature-card">
          <div class="feature-icon">🎵</div>
          <div class="feature-content">
            <h3>Voice Messages</h3>
            <p>Hear your favorite characters speak to you with realistic voice messages.</p>
          </div>
        </div>
        
        <div class="feature-card">
          <div class="feature-icon">🎬</div>
          <div class="feature-content">
            <h3>Exclusive Videos</h3>
            <p>Watch unique video content created just for premium members.</p>
          </div>
        </div>
      </div>
      
      <div class="subscription-action">
        <SubscribeButton 
          buttonText="Unlock Premium" 
          @subscribe="handleSubscription"
        />
      </div>
      
      <div class="testimonials">
        <h3>What our members say</h3>
        <div class="testimonial">
          <p>"The premium features are absolutely worth it! Voice messages make the experience so much more immersive."</p>
          <div class="testimonial-author">- Sarah K.</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SubscribeButton from '@/components/SubscribeButton.vue'

export default {
  name: 'SubscriptionExample',
  components: {
    SubscribeButton
  },
  methods: {
    handleSubscription(subscriptionType) {
      console.log(`User selected ${subscriptionType} subscription`)
      // Here you would handle the subscription process
      this.$router.push({
        path: '/subscription-confirmation',
        query: { type: subscriptionType }
      })
    }
  }
}
</script>

<style scoped>
.subscription-example {
  max-width: 800px;
  margin: 0 auto;
  padding: 20px;
  color: var(--tg-theme-text-color, #000);
}

h1 {
  text-align: center;
  margin-bottom: 40px;
  font-size: 32px;
  font-weight: 700;
  color: #6C5CE7;
}

.content-section {
  background-color: var(--tg-theme-bg-color, white);
  border-radius: 20px;
  padding: 32px;
  box-shadow: 0 8px 24px rgba(108, 92, 231, 0.15);
}

.intro-text {
  text-align: center;
  margin-bottom: 40px;
}

.intro-text h2 {
  margin-top: 0;
  margin-bottom: 16px;
  font-size: 24px;
  color: var(--tg-theme-text-color, #000);
}

.intro-text p {
  margin-bottom: 0;
  font-size: 16px;
  color: var(--tg-theme-hint-color, #666);
  max-width: 500px;
  margin: 0 auto;
}

.premium-features {
  display: flex;
  flex-direction: column;
  gap: 20px;
  margin-bottom: 40px;
}

.feature-card {
  display: flex;
  align-items: flex-start;
  gap: 16px;
  padding: 20px;
  background-color: var(--tg-theme-secondary-bg-color, #f5f5f5);
  border-radius: 16px;
  transition: transform 0.2s;
}

.feature-card:hover {
  transform: translateY(-4px);
}

.feature-icon {
  font-size: 32px;
  width: 48px;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.feature-content h3 {
  margin: 0 0 8px;
  font-size: 18px;
}

.feature-content p {
  margin: 0;
  color: var(--tg-theme-hint-color, #666);
  font-size: 14px;
}

.subscription-action {
  display: flex;
  justify-content: center;
  margin-bottom: 40px;
}

.testimonials {
  text-align: center;
  margin-top: 40px;
  padding: 20px;
  background-color: #F3F1FF;
  border-radius: 16px;
}

.testimonials h3 {
  margin-top: 0;
  margin-bottom: 16px;
  font-size: 18px;
  color: #6C5CE7;
}

.testimonial {
  font-style: italic;
  max-width: 500px;
  margin: 0 auto;
}

.testimonial p {
  margin-bottom: 8px;
}

.testimonial-author {
  font-weight: 600;
  font-style: normal;
  color: var(--tg-theme-hint-color, #666);
}

@media (max-width: 768px) {
  .content-section {
    padding: 24px;
  }
}
</style> 